import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const blockProducts = () => {
	initSliders('.block-products .slider-content .swiper');
};

export default blockProducts;
